<template>
  <div class="offer-search-results">
    <b-table
      :sort:by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      striped
      hover
      :fields="gridFields"
      :items="filteredRecords"
      :tbody-tr-class="rowClass"
      :busy="busy"
      :per-page="20"
      :current-page="currentPage"
      :sort-compare="customSortCompare"
    >
      <div slot="table-busy" class="text-center my-2">
        <i class="fa fa-spinner fa-pulse"></i>
        <strong>Working...</strong>
      </div>
      <template slot="top-row" slot-scope="{ fields }">
    <td v-for="field in fields" :key="field.key">
      <input v-model="filters[field.key]" :placeholder="field.label"
       v-if="field.key !== 'actions' && 
       field.key !== 'current_status'">
      <b-form-checkbox v-if="field.key === 'current_status'" v-model="filters[field.key]"></b-form-checkbox>
    </td>
  </template>
      <template slot="copay_offer_name" slot-scope="data">
        <div v-if="isAdmin && getEffectiveStatus(data.item) !== 'deleted'">
          <router-link
            :to="{ name: 'offer-item', params: { copay_offer_id: data.item.copay_offer_id, offer_status_text: data.item.offer_status_text }}"
          >{{data.value}}</router-link>
        </div>
        <span v-if="(!isAdmin && isApprover) || getEffectiveStatus(data.item) === 'deleted'">{{data.value}}</span>
        <div v-if="(!isAdmin && isApprover) && getEffectiveStatus(data.item) !== 'new'">
          <a href @click.prevent="$emit('view-active', data.item)">View Published</a>
        </div>
      </template>
      <template slot="ndc_num" slot-scope="data">
        <div v-for="item in data.value" :key="item">{{item}}</div>
      </template>
      <template slot="offer_status_text" slot-scope="data">{{ data.value | snakeToTitleCase}}</template>
      <template slot="actions" slot-scope="data">
        <div v-if="(isAdmin || isApprover) && data.item.offer_status_text === 'pending_approval'">
          <router-link
            :to="{ name: 'offer-item', params: { copay_offer_id: data.item.copay_offer_id, offer_status_text: data.item.offer_status_text }}"
          >View for Approval</router-link>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item) !== 'new' && data.item.offer_status_text === 'edit'">
          <a href @click.prevent="$emit('view-active', data.item)">View Published</a>
        </div>
        <div v-if="isAdmin && (data.item.offer_status_text === 'edit' || data.item.offer_status_text === 'new' || data.item.offer_status_text === 'denied')">
          <a href @click.prevent="$emit('request-approval', data.item)">Request Approval</a>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item).toLowerCase() === 'new' && (data.item.offer_status_text === 'new' || data.item.offer_status_text === 'edit' || data.item.offer_status_text === 'pending_approval')">
          <a href @click.prevent="$emit('cancel-update', data.item)">Delete</a>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item).toLowerCase() !== 'new' && data.item.offer_status_text === 'pending_approval'">
          <a href @click.prevent="$emit('cancel-update', data.item)">Cancel Approval Request</a>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item).toLowerCase() !== 'new' && data.item.offer_status_text === 'edit'">
          <a href @click.prevent="$emit('cancel-update', data.item)">Cancel Edit</a>
        </div>
        <div v-if="isApprover && data.item.offer_status_text === 'pending_approval'">
          <a href @click.prevent="$emit('approve', data.item)">Approve</a>
        </div>
        <div v-if="isApprover && data.item.offer_status_text === 'approved'">
          <a href @click.prevent="$emit('publish', data.item)">Publish</a>
        </div>
      </template>
    </b-table>
    <b-pagination
      align="center"
      :total-rows="totalRows"
      v-model="currentPage"
      :per-page="size"
    ></b-pagination>
  </div>
</template>
<script>
export default {
  name: "OfferSearchResults",
  props: {
    searchResults: {
      required: true,
      type: Object
    },
    busy: {
      required: false,
      type: Boolean
    },
    isAdmin: {
      required: false,
      type: Boolean
    },
    isApprover: {
      required: false,
      type: Boolean
    }
  },
  data() {
    return {
      currentPage: 1,
      size: 20,
      sortBy: "offer_effective_date",
      sortDesc: true,
      totalRows: 0,
      gridFields: [
        { key: "copay_offer_name", label: "Offer Name", sortable: true },
        {
          key: "manufacture_name",
          label: "Manufacturer",
          sortable: true
        },
        {
          key: "offer_effective_date",
          label: "Effective Date",
          sortable: true,
          sortByFormatted: true,
          formatter: value => {
            return value !== '' ? new Date(value).toLocaleDateString() : '';
          }
        },
        {
          key: "offer_end_date",
          label: "End Date",
          sortable: true,
          formatter: value => {
            return value !== '' ? new Date(value).toLocaleDateString() : '';
          }
        },
        {
          key: "current_status",
          label: "Active",
          sortable: true
        },
        {
          key: "offer_status_text",
          label: "Workflow Status",
          sortable: true
        },
        {
          key: "actions",
          label: "",
          sortable: false
        }
      ],
      filters: {
        copay_offer_name: '',
        manufacture_name: '',
        offer_effective_date: '',
        offer_end_date: '',
        current_status: '',
        offer_status_text: ''
    }
    };
  },
  computed: {
    filteredRecords () {
      if(this.searchResults.results) {
      this.searchResults.results.forEach(item => {
        item['current_status'] = this.toTitleCase(this.getEffectiveStatus(item));
        item['offer_effective_date'] = new Date(item['offer_effective_date']).toLocaleDateString();
        item['offer_end_date'] = new Date(item['offer_end_date']).toLocaleDateString();
      });
      const filtered = this.searchResults.results.filter(item => {
        return Object.keys(this.filters).every(key => 
            String(item[key].toLowerCase()).includes(this.filterOffer(key).toLowerCase()))
      })
      return filtered.length > 0 ? this.setPagination(filtered) : [{
        copay_offer_name: '',
        manufacture_name: '',
        offer_effective_date: '',
        offer_end_date: '',
        current_status: '',
        offer_status_text: ''        
      }] 
    }
      }
  },
  methods: {
    rowClass(item, type) {
      if (!item) return;
      if (
        item.is_pending_inactivation ||
        item.status === "inactive" ||
        item.status === "deleted"
      ) {
        return "table-warning";
      }
    },
    getEffectiveStatus(item) {
      const now = new Date().toISOString();
      if (
        item.current_offer_effective_date &&
        now < item.current_offer_effective_date
      ) {
        return `inactive until ${new Date(
          item.current_offer_effective_date
        ).toLocaleDateString()}`;
      } else if (
        item.current_offer_end_date &&
        item.current_offer_end_date < now
      ) {
        return "inactive";
      } else if (
        item.current_status === "active" &&
        item.current_offer_end_date &&
        item.current_offer_end_date > now &&
        item.current_offer_end_date.indexOf('2099-01-01') === -1
      ) {
        return `active until ${new Date(
          item.current_offer_end_date
        ).toLocaleDateString()}`;
      }
      return item.current_status;
    },
    setPagination(filteredRecords) {
      this.totalRows = filteredRecords.length;
      return filteredRecords;
   },
    filterOffer(key) {
      if(key === 'current_status' && !this.filters[key]) {
        this.filters[key] = '';
      } else if(key === 'current_status' && this.filters[key]) {
        this.filters[key] = 'Active ';
      }
      return this.filters[key];
   },
   customSortCompare(itemA, itemB, key) {
      if (key === 'offer_effective_date' || key === 'offer_end_date') {
        // Convert the string formatted date to a number that can be compared
        // Get the values being compared from the items
        let a = itemA[key];
        let b = itemB[key];
        // Split them into an array of parts (dd, mm, and yyyy)
        a = a.split('/');
        b = b.split('/');
        // convert string parts to numbers
        a = (parseInt(a[2], 10) * 10000) + (parseInt(a[1], 10) * 100) + parseInt(a[0]);
        b = (parseInt(b[2], 10) * 10000) + (parseInt(b[1], 10) * 100) + parseInt(b[0]);
        // Return the comparison result
        return a - b;
      } else {
        // Let b-table handle sorting other fields (other than `date` field)
        return false;
      }
    },
    toTitleCase(str) {
      return str.toLowerCase().split(' ').map(function (word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
      }).join(' ');
    }
  }
};
</script>
<style lang="scss" scoped>
.offer-search-results {
  overflow: auto;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/OfferSearchResults.vue